/* globals AWS, apigClientFactory */

(function(window, angular, undefined) {
angular.module('formApp')
    .factory('FormService', ['API_URL', 'API_IDENTITY_POOL', '$q', '$http', 'errorHandler', 'uuid', '$window', '$rootScope',function(apiUrl, apiIdentityPool, $q, $http, errorHandler, uuid, $window,$rootScope) {  
        
        var apigClient;
        var applicationId = '';
        var session;
        var customHeaders;

        customHeaders = {
            "x-application-source": "qnb-website",
            "x-application-source-details": navigator.userAgent,
            "x-session-id-for-tracing":  uuid.v4()// initial uuid for tracing - gets replaced by application uuid after first submission
        };

        if(sessionStorage.getItem('eQuote')) {
            customHeaders['orc-id'] = "sa-equote-orc";
        }

        AWS.config.region = 'eu-central-1'; // Replace with the region you deploy
        var cognitoidentity;
        var params = {
            IdentityPoolId: apiIdentityPool
        };

        function setRequestHeaders() {
            return angular.extend({"x-request-id-for-tracing": uuid.v4()}, customHeaders);
        }
        
        function init() {
            clearInterval(session);
            session = setInterval(function() {
                init();
            }, 3000000); // 50 mins

            var deferred = $q.defer();
            cognitoidentity = new AWS.CognitoIdentity();

                // Generate a Cognito ID for the 1st time, so IdentityId could be kept for future use
            cognitoidentity.getId(params, function (err, data) {
                if (err) {
                    //errorHandler.reportErrors(err,'redirect','c0gn1:'+err.message);
                    //console.log(err, err.stack); // an error occurred
                // } else {
                //    console.log(data); // successful response
                    apigClient = apigClientFactory.newClient({
                        region: 'eu-central-1', // Replace with the region you deploy
                        invokeUrl: apiUrl
                    });
                    deferred.resolve();
                } else {
                    var cognitoParams = {
                        IdentityId: data.IdentityId
                    };

                    // Retrieve temp credentials with IdentityId
                    cognitoidentity.getCredentialsForIdentity(cognitoParams, function (err, data) {
                        if (err) { 
                            //errorHandler.reportErrors(err,'redirect');
                        // } else {
                        //    console.log(data.Credentials); // successful response
                            apigClient = apigClientFactory.newClient({
                                region: 'eu-central-1', // Replace with the region you deploy
                                invokeUrl: apiUrl
                            });
                            deferred.resolve();
                        } else {
                            apigClient = apigClientFactory.newClient({
                                accessKey: data.Credentials.AccessKeyId,
                                secretKey: data.Credentials.SecretKey,
                                sessionToken: data.Credentials.SessionToken,
                                region: 'eu-central-1', // Replace with the region you deploy
                                invokeUrl: apiUrl
                            });
                            deferred.resolve();
                        }
                    });
                }
            });
            return deferred.promise;
        
        }
        
        function getSchema(version) { 
            var params = {
                // This is where any header, path, or querystring request params go. The key is the parameter named as defined in the API
            },
            body = {
                // This is where you define the body of the request,
            },
            additionalParams = {
                // If there are any unmodeled query parameters or headers that must be
                // sent with the request, add them here.
                
                // headers: customHeaders,
                headers: setRequestHeaders(),
                queryParams: {}
            };
            if (version) {
                params.version = version;
            }
            var deferred = $q.defer();
            apigClient.schemaGet(params, body, additionalParams).then(function success(result) {
                deferred.resolve(result);
            }, function error(error) {
                deferred.reject(error);
            });

            return deferred.promise;
            
        }
        
        function getApplicationId(data) {      
            var params = {},
        body = {
                    params: data
                },
                additionalParams = {
                    headers: setRequestHeaders()
                };

            var deferred = $q.defer();
            if (applicationId !== '') {
                customHeaders['x-session-id-for-tracing'] = applicationId;
                deferred.resolve({'applicationId': applicationId});
            } else {
                apigClient.insuranceFormPost(params, body, additionalParams).then(function success(result) {
                    var applicationId = result.data.uri.split('/').pop();
                    customHeaders['x-session-id-for-tracing'] = applicationId;
                    deferred.resolve({'applicationId': applicationId});
                }, function error(error) {
                    deferred.reject(error);
                });
            }
            return deferred.promise;
        }

        function setApplicationId(id) {
            applicationId = id;
            customHeaders['x-session-id-for-tracing'] = applicationId;
            // Store the Application ID in case the page gets refreshed
            $window.sessionStorage.setItem('formStateUri', applicationId);
        }

        function setQuoteExpiry(isQuoteExpired){
            $window.sessionStorage.setItem('isQuoteExpired', isQuoteExpired);
        }

        function  postnewQuoteFromAnOldQuote(){
            var params = {
                "insuranceformid": sessionStorage.getItem("formStateUri"),
                },
                body = {
                    "params": {}
                },
                additionalParams = {
                headers: setRequestHeaders()
            };

            var deferred = $q.defer();
            apigClient.newQuoteFromAnOldQuote(params, body, additionalParams).then(function success(result) {
                deferred.resolve(result);
            }, function error(error) {
                deferred.reject(error);
            });
            deferred.promise.cancel = function () {
                deferred.resolve('CANCELLED');
            };
            return deferred.promise;
        }

        function getApplication() {
            var params = {
                    "insuranceformid": applicationId
                },
                body = {},
                additionalParams = {
                    headers: setRequestHeaders(),
                    queryParams: {
                        't': Date.now()
                    }
                };
                
            var deferred = $q.defer();
            apigClient.insuranceFormInsuranceformidGet(params, body, additionalParams).then(function success(result) {
                deferred.resolve(result);
            }, function error(error) {
                deferred.reject(error);
            });

            deferred.promise.cancel = function () {
                deferred.resolve('CANCELLED');
            };

            return deferred.promise;
        }

        function getRunningTotals() {
            var params = {
                    "insuranceformid": applicationId,
                    "application": 'runningTotals'
                },
                body = {},  
                additionalParams = {
                    headers: setRequestHeaders(),
                    queryParams: {
                        't': Date.now()
                    }
                };

            var deferred = $q.defer();
            apigClient.insuranceFormInsuranceformidApplicationGet(params, body, additionalParams).then(function success(result) {
                deferred.resolve(result);
            }, function error(error) {
                deferred.reject(error);
            });

            deferred.promise.cancel = function () {
                deferred.resolve('CANCELLED');
            };

            return deferred.promise;
        }

        function getProducts() {
            var params = {
                    "insuranceformid": applicationId,
                    "application": 'products'
                },
                body = {},  
                additionalParams = {
                    headers: setRequestHeaders()
                };

            var deferred = $q.defer();
            apigClient.insuranceFormInsuranceformidApplicationGet(params, body, additionalParams).then(function success(result) {
                deferred.resolve(result);
            }, function error(error) {
                deferred.reject(error);
            });

            return deferred.promise;
        }
        
        function postPet(data) {
            var params = {
                    "insuranceformid": applicationId,
                    "application": 'application',
                    "type": 'pets',
                    "petid": data.type,
                    "details": 'details'
                },
                body = data.details,
                additionalParams = {
                    headers: setRequestHeaders()
                };
            var deferred = $q.defer();
            apigClient.insuranceFormInsuranceformidApplicationTypePetidDetailsPost(params, body, additionalParams).then(function success(result) {
                deferred.resolve(result);
            }, function error(error) {
                deferred.reject(error);
            });

            return deferred.promise;
        }

        function updatePet(data) {
            var params = {
                    "insuranceformid": applicationId,
                    "application": 'application',
                    "type": 'pets',
                    "petid": data.uri.split('/').pop(),
                    "details": 'details'
                },
                body = data.details,
                additionalParams = {
                    headers: setRequestHeaders()
                };

            var deferred = $q.defer();
            apigClient.insuranceFormInsuranceformidApplicationTypePetidDetailsPost(params, body, additionalParams).then(function success(result) {
                deferred.resolve(result);
            }, function error(error) {
                deferred.reject(error);
            });

            return deferred.promise;
        }

        function updatePetType(data) {
            var params = {
                    "insuranceformid": applicationId,
                    "application": 'application',
                    "type": 'pets',
                    "petid": data.uri.split('/').pop(),
                    "details": ''
                },
                body = {
                    type: data.type
                },
                additionalParams = {
                    headers: setRequestHeaders()
                };

            var deferred = $q.defer();
            apigClient.insuranceFormInsuranceformidApplicationTypePetidDetailsPost(params, body, additionalParams).then(function success(result) {
                deferred.resolve(result);
            }, function error(error) {
                deferred.reject(error);
            });

            return deferred.promise;
        }

        function deletePet(data) {
            var params = {
                    "insuranceformid": applicationId,
                    "application": 'application',
                    "type": 'pets',
                    "petid": data.uri.split('/').pop()
                },
                body = {},
                additionalParams = {
                    headers: setRequestHeaders()
                };

            var deferred = $q.defer();
            apigClient.insuranceFormInsuranceformidApplicationTypePetidDelete(params, body, additionalParams).then(function success(result) {
                deferred.resolve(result);
            }, function error(error) {
                deferred.reject(error);
            });

            return deferred.promise;
        }

        function postChosenCover(data) {
            var petId = data.uri.split('/').pop(),
                cover = data.chosenCover;
                // console.log('quote', data.chosenCover);

            delete cover.total;

            var params = {
                    "insuranceformid": applicationId,
                    "application": 'application',
                    "type": 'pets',
                    "petid": petId,
                    "details": 'chosenCover'
                },
                body = cover,
                additionalParams = {
                    headers: setRequestHeaders()
                };

            var deferred = $q.defer();
            apigClient.insuranceFormInsuranceformidApplicationTypePetidDetailsPost(params, body, additionalParams).then(function success(result) {
                // console.log('form data', result );
                deferred.resolve(result);
            }, function error(error) {
                deferred.reject(error);
            });

            return deferred.promise;
        }

        function postQuestions(data, petUri) {
            var params = {
                    "insuranceformid": applicationId,
                    "application": 'application',
                    "type": 'pets',
                    "petid": data.uri.split('/')[3],
                    "details": 'extraQuestions'
                },
                body = data.extraQuestions,
                additionalParams = {
                    headers: setRequestHeaders()
                };
            return apigClient.insuranceFormInsuranceformidApplicationTypePetidDetailsPost(params, body, additionalParams);
        }

        // post blockedQuestions step 4
            function postBlockedQuestions(data, petUri) {
            var params = {
                    "insuranceformid": applicationId,
                    "application": 'application',
                    "type": 'pets',
                    "petid": data.uri.split('/')[3],
                    "details": 'extraQuestionsWhenBlocked'
                },
                body = data.extraQuestions,
                additionalParams = {
                    headers: setRequestHeaders()
                };
            return apigClient.insuranceFormInsuranceformidApplicationTypePetidDetailsPost(params, body, additionalParams);
        }           

        function postDeclarations(data) {
            var params = {
                    "insuranceformid": applicationId,
                    "application": 'application',
                    "type": 'declarations'
                },
                body = data,
                additionalParams = {
                    headers: setRequestHeaders()
                };
            return apigClient.insuranceFormInsuranceformidApplicationTypePost(params, body, additionalParams);
        }
        
        function postCover(data) {
            var params = {
                    "insuranceformid": applicationId,
                    "application": 'application',
                    "type": 'cover'
                },
                body = data,
                additionalParams = {
                    headers: setRequestHeaders()
                };
            return apigClient.insuranceFormInsuranceformidApplicationTypePost(params, body, additionalParams);
        }

        function postCaptchaToken(data) {
            var params = {},
                body = data,
                additionalParams = {
                    headers: setRequestHeaders()
                };
            return apigClient.insuranceFormInsuranceformCaptchaPost(params, body, additionalParams);
        }            

        function postAboutYou(data) {
            var params = {
                    insuranceformid: applicationId,
                    application: 'application',
                    type: 'aboutYou',
                },
                body = data,
                additionalParams = {
                    headers: setRequestHeaders()
                };
            return apigClient.insuranceFormInsuranceformidApplicationTypePost(params, body, additionalParams);
        }

        function postPayment(data) {
            var params = {
                    'insuranceformid': applicationId,
                    'application': 'payment',
                    'type': 'directDebit',
                },
                body = data,
                additionalParams = {
                    headers: setRequestHeaders()
                };
            return apigClient.insuranceFormInsuranceformidApplicationTypePost(params, body, additionalParams);
        }

        function postPurchased() {
            var params = {
                    "insuranceformid": applicationId,
                    "state": "purchased"
                },
                body = {},
                additionalParams = {
                    headers: setRequestHeaders()
                };
                
            var deferred = $q.defer();
            apigClient.applicationprefixInsuranceFormInsuranceformidApplicationStatePost(params, body, additionalParams).then(function success(result) {
                deferred.resolve(result);
            }, function(error) {
                deferred.reject(error);
            });

            return deferred.promise;
        }

        function postCharitableDonation(data) {
            var params = {
                    'insuranceformid': applicationId,
                    'application': 'application',
                    'type': 'charitableDonation',
                },
                body = data,
                additionalParams = {
                    headers: setRequestHeaders()
                };
            return apigClient.insuranceFormInsuranceformidApplicationTypePost(params, body, additionalParams);
        }

        function postCopsPayment(cardRegsitered,details,name,house,postcode,ammount) {
    
            var cHouse,
                cPost,
                data;

            if(cardRegsitered ==='N'){
                cHouse = house;
                cPost = postcode;
                data = {
                    "houseNameOrNumber": cHouse,
                    "streetName": "",
                    "town": "",
                    "county": "",
                    "country": "UK",
                    "postcode": cPost
                };
            }
            else{
                cHouse = details.houseNameOrNumber;
                cPost = details.postCode;
                data = {
                    "houseNameOrNumber": cHouse, 
                    "streetName":details.street,
                    "town": details.town,
                    "county": details.county,
                    "country": "UK",
                    "postcode": cPost
                };
            }

            data.amount = ammount;
            data.cardHolderName = name;
            data.insuranceFormUri = "/sa/insuranceForm/"+applicationId;

            var params = {},
                body = data,
                additionalParams = {
                    headers: setRequestHeaders()
                };

            return apigClient.copsPaymentPost(params, body, additionalParams);
        }

        function postBankCheck(data, url) {

            var params = {},
                body = data,
                additionalParams = {
                    headers: setRequestHeaders()
                };
            return apigClient.bankdetailsPost(params, body, additionalParams);

        }

        function getAddress(data) {
            var params = {},
                body = {},
                additionalParams = {
                    headers: setRequestHeaders(),
                    queryParams: data
                };
                
            var deferred = $q.defer();
            apigClient.addressdetailsGet(params, body, additionalParams).then(function success(result) {
                deferred.resolve(result);
            }, function(error) {
                deferred.reject(error);
            });

            return deferred.promise;

        }

        function saveQuote() {
            var params = {
                    "insuranceformid": applicationId,
                    "state": "saved"
                },
                body = {},
                additionalParams = {
                    headers: setRequestHeaders()
                };
                
            var deferred = $q.defer();
            apigClient.applicationprefixInsuranceFormInsuranceformidApplicationStatePost(params, body, additionalParams).then(function success(result) {
                deferred.resolve(result);
            }, function(error) {
                deferred.reject(error);
            });

            return deferred.promise;
        }

        function getQuote(data) {
            var params = {},
                body = {},
                additionalParams = {
                    headers: setRequestHeaders(),
                    queryParams: data
                };
                
            var deferred = $q.defer();
            apigClient.quoteGet(params, body, additionalParams).then(function success(result) {
                deferred.resolve(result);
            }, function(error) {
                deferred.reject(error);
            });

            return deferred.promise;
        }

        function heartbeat() {
            var headers = setRequestHeaders();
            headers['x-date'] = moment().utc().format("ddd, DD MMM YYYY HH:mm:ss UTC");
            var params = {
                    "quoteId": "/sa/insuranceForm/" + applicationId 
                },
                body = {},
                additionalParams = {
                    headers: headers
                };
            return apigClient.quoteWatcherPost(params, body, additionalParams);

        }

        function getSummary() {
            var params = {
                    "insuranceformid": applicationId
                },
                body = {},
                additionalParams = {
                    headers: setRequestHeaders(),
                    queryParams: {
                        't': Date.now()
                    }
                };
                
            var deferred = $q.defer();
            apigClient.summaryGet(params, body, additionalParams).then(function success(result) {
                deferred.resolve(result);
            }, function error(error) {
                deferred.reject(error);
            });

            return deferred.promise;
        }


        function postPostPolicyMarketing(data) {
            var params = {
                    "insuranceformid": applicationId,
                    "application": 'application',
                    "type": 'postPolicyMarketing'
                },
                body = data,
                additionalParams = {
                    headers: setRequestHeaders()
                };

            var deferred = $q.defer();
            apigClient.insuranceFormInsuranceformidApplicationTypePost(params, body, additionalParams).then(function success(result) {
                deferred.resolve(result);
            }, function error(error) {
                deferred.reject(error);
            });

            return deferred.promise;
        }

        function getMatchingCovernote(data) {
            var params = {
                    "insuranceformid": applicationId
                },
                body = data,
                additionalParams = {
                    headers: setRequestHeaders(),
                    queryParams: {
                        't': Date.now()
                    }
                };
                
            var deferred = $q.defer();
            apigClient.matchingCovernotePost(params, body, additionalParams).then(function success(result) {
                deferred.resolve(result);
            }, function error(error) {
                deferred.reject(error);
            });

            deferred.promise.cancel = function () {
                deferred.resolve('CANCELLED');
            };

            return deferred.promise;
        }


        function postRecognisedCovernote(coverNoteId, recognised, data) {
            var action = recognised ? 'Y' : 'N';
            var params = {},
                body = {
                    qnbFormId: applicationId,
                    coverNoteFormId: coverNoteId,
                    action: action,
                    contactNumber: data.contactNumber,
                    email: data.email,
                    quoteFollowupMarketingOptOut: data.quoteFollowupMarketingOptOut,
                    dateOfBirth: data.dateOfBirth
                },
                additionalParams = {
                    headers: setRequestHeaders()
                };
                
            var deferred = $q.defer();
            apigClient.recognisedCovernotePost(params, body, additionalParams).then(function success(result) {
                deferred.resolve(result);
            }, function(error) {
                deferred.reject(error);
            });

            return deferred.promise;
        }

        function clearAllProduct() {
            var params = {
                "insuranceformid": applicationId
            },
            body = {},
            additionalParams = {
                headers: setRequestHeaders(),
            };
            var deferred = $q.defer();
            apigClient.removeChosenCover(params, body, additionalParams).then(function success(result) {
                deferred.resolve(result);
            }, function error(error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function getBravDetails(bravRef) {
            var params = {
                "bravRef": bravRef
            },
                body = {},
                additionalParams = {
                    headers: setRequestHeaders(),
                };
            var deferred = $q.defer();
            apigClient.bravRefGet(params, body, additionalParams).then(function success(result) {
                deferred.resolve(result);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }
    //   getRunningTotals().then(function success() {
            //  console.log("just got the running totals");
        return {
            init: init,
            getSchema: getSchema,
            getApplicationId: getApplicationId,
            getApplication: getApplication,
            getRunningTotals: getRunningTotals,
            getProducts: getProducts,
            postPet: postPet,
            updatePet: updatePet,
            updatePetType: updatePetType,
            deletePet: deletePet,
            postChosenCover: postChosenCover,
            postQuestions:postQuestions,
            postBlockedQuestions:postBlockedQuestions,
            postDeclarations:postDeclarations,
            postCover: postCover,
            postAboutYou: postAboutYou,
            postBankCheck:postBankCheck,
            postPayment:postPayment,
            postPurchased:postPurchased,
            postCharitableDonation: postCharitableDonation,
            postCopsPayment: postCopsPayment,
            getAddress: getAddress,
            getQuote: getQuote,
            saveQuote: saveQuote,
            setApplicationId: setApplicationId,
            heartbeat: heartbeat,
            getSummary: getSummary,
            postPostPolicyMarketing: postPostPolicyMarketing,
            getMatchingCovernote: getMatchingCovernote,
            postRecognisedCovernote: postRecognisedCovernote,
            postCaptchaToken: postCaptchaToken,
            setQuoteExpiry: setQuoteExpiry,
            postnewQuoteFromAnOldQuote: postnewQuoteFromAnOldQuote,
            clearAllProduct: clearAllProduct,
            getBravDetails: getBravDetails
        };
//    });

    }]);
    
})(window, window.angular);